<template>
  <div>
    <SectionWrapper class="whiteframe shadowframe">
      <h1 class="headline">Create new Account</h1>
      <Register
        :enable-third-party="true"
        :registration-data="registrationData"
        @continue="next"
      />
    </SectionWrapper>
    <DividerSeparator>
      <DecoratedButton
        type="link"
        :route="{ name: pages.AUTH_LOGIN }"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        ALREADY HAVE AN ACCOUNT?
      </DecoratedButton>
    </DividerSeparator>
  </div>
</template>

<script>
import Register from "@/components/partials/auth/Register";

export default {
  name: "auth-register-form",
  props: {
    registrationData: {
      type: Object,
      default: null
    }
  },
  components: { Register },
  methods: {
    next() {
      this.$emit("continue");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.headline {
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 2rem;
}
</style>
